var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty1Default(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 498,
    viewBox: "0 0 600 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 290,
    r: 96,
    stroke: "white",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 148,
    r: 48.5,
    stroke: "white",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 393,
    r: 72.5,
    stroke: "white",
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 525,
    cy: 423,
    r: 72.5,
    stroke: "white",
    strokeWidth: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 171,
    r: 72.5,
    stroke: "white",
    strokeWidth: 5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 40.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 55.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 70.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 85.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 100.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 115.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 130.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 145.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 455,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 230.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 245.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 260.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 275.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 290.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 305.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 320.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 335.5,
    r: 3.5,
    fill: "#D63E3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.594 111C470.43 111 477.594 118.163 477.594 127V299.581C477.594 308.418 470.43 315.581 461.594 315.581H185.335L158.416 342.5V315.581H127.501C118.664 315.581 111.501 308.418 111.501 299.581V127C111.501 118.163 118.664 111 127.501 111H461.594Z",
    fill: "#D63E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.5 9C182.663 9 175.5 16.1634 175.5 25V126C175.5 134.837 182.663 142 191.5 142H365.5L383 159.5V142H397.5C406.337 142 413.5 134.837 413.5 126V25C413.5 16.1634 406.337 9 397.5 9H191.5Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.594 99C458.43 99 465.594 106.163 465.594 115V287.581C465.594 296.418 458.43 303.581 449.594 303.581H173.335L146.416 330.5V303.581H115.501C106.664 303.581 99.5007 296.418 99.5007 287.581V115C99.5007 106.163 106.664 99 115.501 99H449.594Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87 253L0 263.5L23.5 283.5L87 253Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 290.5L83.5 266L64.5 298L55 290.5Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 218.5L75.5 241L46 236.5L38.5 218.5Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M567 82L501.5 111L569.5 105.5L567 82Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M552 139L515.5 125L543.5 154L552 139Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M529 66.5L501.5 83.5L522.5 54.5L529 66.5Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.5 0C194.663 0 187.5 7.16345 187.5 16V117C187.5 125.837 194.663 133 203.5 133H377.5L395 150.5V133H409.5C418.337 133 425.5 125.837 425.5 117V16C425.5 7.16344 418.337 0 409.5 0H203.5Z",
    fill: "#D63E3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M237.523 89L224.205 42.4545H234.955L242.659 74.7955H243.045L251.545 42.4545H260.75L269.227 74.8636H269.636L277.341 42.4545H288.091L274.773 89H265.182L256.318 58.5682H255.955L247.114 89H237.523ZM305.335 89.6818C301.744 89.6818 298.653 88.9545 296.062 87.5C293.487 86.0303 291.502 83.9545 290.108 81.2727C288.714 78.5758 288.017 75.3864 288.017 71.7045C288.017 68.1136 288.714 64.9621 290.108 62.25C291.502 59.5379 293.464 57.4242 295.994 55.9091C298.54 54.3939 301.525 53.6364 304.949 53.6364C307.252 53.6364 309.396 54.0076 311.381 54.75C313.381 55.4773 315.123 56.5758 316.608 58.0455C318.108 59.5152 319.275 61.3636 320.108 63.5909C320.941 65.803 321.358 68.3939 321.358 71.3636V74.0227H291.881V68.0227H312.244C312.244 66.6288 311.941 65.3939 311.335 64.3182C310.729 63.2424 309.888 62.4015 308.812 61.7955C307.752 61.1742 306.517 60.8636 305.108 60.8636C303.638 60.8636 302.335 61.2045 301.199 61.8864C300.078 62.553 299.199 63.4545 298.562 64.5909C297.926 65.7121 297.6 66.9621 297.585 68.3409V74.0455C297.585 75.7727 297.903 77.2652 298.54 78.5227C299.191 79.7803 300.108 80.75 301.29 81.4318C302.472 82.1136 303.873 82.4545 305.494 82.4545C306.57 82.4545 307.555 82.303 308.449 82C309.343 81.697 310.108 81.2424 310.744 80.6364C311.381 80.0303 311.866 79.2879 312.199 78.4091L321.153 79C320.699 81.1515 319.767 83.0303 318.358 84.6364C316.964 86.2273 315.161 87.4697 312.949 88.3636C310.752 89.2424 308.214 89.6818 305.335 89.6818ZM335.79 42.4545V47.3636C335.79 48.7576 335.517 50.1818 334.972 51.6364C334.441 53.0758 333.729 54.4394 332.835 55.7273C331.941 57 330.964 58.0833 329.903 58.9773L325.631 56.4545C326.388 55.2576 327.055 53.9318 327.631 52.4773C328.222 51.0227 328.517 49.3333 328.517 47.4091V42.4545H335.79ZM340.864 89V54.0909H350.25V60.1818H350.614C351.25 58.0152 352.318 56.3788 353.818 55.2727C355.318 54.1515 357.045 53.5909 359 53.5909C359.485 53.5909 360.008 53.6212 360.568 53.6818C361.129 53.7424 361.621 53.8258 362.045 53.9318V62.5227C361.591 62.3864 360.962 62.2652 360.159 62.1591C359.356 62.053 358.621 62 357.955 62C356.53 62 355.258 62.3106 354.136 62.9318C353.03 63.5379 352.152 64.3864 351.5 65.4773C350.864 66.5682 350.545 67.8258 350.545 69.25V89H340.864ZM381.335 89.6818C377.744 89.6818 374.653 88.9545 372.062 87.5C369.487 86.0303 367.502 83.9545 366.108 81.2727C364.714 78.5758 364.017 75.3864 364.017 71.7045C364.017 68.1136 364.714 64.9621 366.108 62.25C367.502 59.5379 369.464 57.4242 371.994 55.9091C374.54 54.3939 377.525 53.6364 380.949 53.6364C383.252 53.6364 385.396 54.0076 387.381 54.75C389.381 55.4773 391.123 56.5758 392.608 58.0455C394.108 59.5152 395.275 61.3636 396.108 63.5909C396.941 65.803 397.358 68.3939 397.358 71.3636V74.0227H367.881V68.0227H388.244C388.244 66.6288 387.941 65.3939 387.335 64.3182C386.729 63.2424 385.888 62.4015 384.812 61.7955C383.752 61.1742 382.517 60.8636 381.108 60.8636C379.638 60.8636 378.335 61.2045 377.199 61.8864C376.078 62.553 375.199 63.4545 374.562 64.5909C373.926 65.7121 373.6 66.9621 373.585 68.3409V74.0455C373.585 75.7727 373.903 77.2652 374.54 78.5227C375.191 79.7803 376.108 80.75 377.29 81.4318C378.472 82.1136 379.873 82.4545 381.494 82.4545C382.57 82.4545 383.555 82.303 384.449 82C385.343 81.697 386.108 81.2424 386.744 80.6364C387.381 80.0303 387.866 79.2879 388.199 78.4091L397.153 79C396.699 81.1515 395.767 83.0303 394.358 84.6364C392.964 86.2273 391.161 87.4697 388.949 88.3636C386.752 89.2424 384.214 89.6818 381.335 89.6818Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.068 241V171.182H146.83V199.989H176.795V171.182H191.523V241H176.795V212.159H146.83V241H132.068ZM203.42 241V188.636H217.943V241H203.42ZM210.716 181.886C208.557 181.886 206.705 181.17 205.159 179.739C203.636 178.284 202.875 176.545 202.875 174.523C202.875 172.523 203.636 170.807 205.159 169.375C206.705 167.92 208.557 167.193 210.716 167.193C212.875 167.193 214.716 167.92 216.239 169.375C217.784 170.807 218.557 172.523 218.557 174.523C218.557 176.545 217.784 178.284 216.239 179.739C214.716 181.17 212.875 181.886 210.716 181.886ZM229.577 241V188.636H243.656V197.773H244.202C245.156 194.523 246.759 192.068 249.009 190.409C251.259 188.727 253.849 187.886 256.781 187.886C257.509 187.886 258.293 187.932 259.134 188.023C259.974 188.114 260.713 188.239 261.349 188.398V201.284C260.668 201.08 259.724 200.898 258.52 200.739C257.315 200.58 256.213 200.5 255.213 200.5C253.077 200.5 251.168 200.966 249.486 201.898C247.827 202.807 246.509 204.08 245.531 205.716C244.577 207.352 244.099 209.239 244.099 211.375V241H229.577ZM268.858 241V188.636H283.381V241H268.858ZM276.153 181.886C273.994 181.886 272.142 181.17 270.597 179.739C269.074 178.284 268.312 176.545 268.312 174.523C268.312 172.523 269.074 170.807 270.597 169.375C272.142 167.92 273.994 167.193 276.153 167.193C278.313 167.193 280.153 167.92 281.676 169.375C283.222 170.807 283.994 172.523 283.994 174.523C283.994 176.545 283.222 178.284 281.676 179.739C280.153 181.17 278.313 181.886 276.153 181.886ZM309.537 210.727V241H295.014V188.636H308.855V197.875H309.469C310.628 194.83 312.571 192.42 315.298 190.648C318.026 188.852 321.332 187.955 325.219 187.955C328.855 187.955 332.026 188.75 334.73 190.341C337.435 191.932 339.537 194.205 341.037 197.159C342.537 200.091 343.287 203.591 343.287 207.659V241H328.764V210.25C328.787 207.045 327.969 204.545 326.31 202.75C324.651 200.932 322.366 200.023 319.457 200.023C317.503 200.023 315.776 200.443 314.276 201.284C312.798 202.125 311.639 203.352 310.798 204.966C309.98 206.557 309.56 208.477 309.537 210.727ZM378.324 261.727C373.619 261.727 369.585 261.08 366.222 259.784C362.881 258.511 360.222 256.773 358.244 254.568C356.267 252.364 354.983 249.886 354.392 247.136L367.824 245.33C368.233 246.375 368.881 247.352 369.767 248.261C370.653 249.17 371.824 249.898 373.278 250.443C374.756 251.011 376.551 251.295 378.665 251.295C381.824 251.295 384.426 250.523 386.472 248.977C388.54 247.455 389.574 244.898 389.574 241.307V231.727H388.96C388.324 233.182 387.369 234.557 386.097 235.852C384.824 237.148 383.188 238.205 381.188 239.023C379.188 239.841 376.801 240.25 374.028 240.25C370.097 240.25 366.517 239.341 363.29 237.523C360.085 235.682 357.528 232.875 355.619 229.102C353.733 225.307 352.79 220.511 352.79 214.716C352.79 208.784 353.756 203.83 355.688 199.852C357.619 195.875 360.188 192.898 363.392 190.92C366.619 188.943 370.153 187.955 373.994 187.955C376.926 187.955 379.381 188.455 381.358 189.455C383.335 190.432 384.926 191.659 386.131 193.136C387.358 194.591 388.301 196.023 388.96 197.432H389.506V188.636H403.926V241.511C403.926 245.966 402.835 249.693 400.653 252.693C398.472 255.693 395.449 257.943 391.585 259.443C387.744 260.966 383.324 261.727 378.324 261.727ZM378.631 229.341C380.972 229.341 382.949 228.761 384.562 227.602C386.199 226.42 387.449 224.739 388.312 222.557C389.199 220.352 389.642 217.716 389.642 214.648C389.642 211.58 389.21 208.92 388.347 206.67C387.483 204.398 386.233 202.636 384.597 201.386C382.96 200.136 380.972 199.511 378.631 199.511C376.244 199.511 374.233 200.159 372.597 201.455C370.96 202.727 369.722 204.5 368.881 206.773C368.04 209.045 367.619 211.67 367.619 214.648C367.619 217.67 368.04 220.284 368.881 222.489C369.744 224.67 370.983 226.364 372.597 227.568C374.233 228.75 376.244 229.341 378.631 229.341ZM432.835 171.182L431.506 220.068H419.028L417.665 171.182H432.835ZM425.267 241.886C423.017 241.886 421.085 241.091 419.472 239.5C417.858 237.886 417.063 235.955 417.085 233.705C417.063 231.477 417.858 229.568 419.472 227.977C421.085 226.386 423.017 225.591 425.267 225.591C427.426 225.591 429.324 226.386 430.96 227.977C432.597 229.568 433.426 231.477 433.449 233.705C433.426 235.205 433.028 236.58 432.256 237.83C431.506 239.057 430.517 240.045 429.29 240.795C428.062 241.523 426.722 241.886 425.267 241.886Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Default);
export default __webpack_public_path__ + "static/media/Property 1=Default.d5a32803bdb379b5c38c96c71220fdb4.svg";
export { ForwardRef as ReactComponent };